<div class="subheader with-padding flgrow">
    <div class="row">
        <div class="col-xl-3 col-lg-4 col-md-6 col-sm-8 maxw600">
            <div class="d-flex">
                <div class="flex-grow-1">
                    <div class="input-group">
                        <input class="form-control" type="text" name="searchTerm"
                            placeholder="{{ 'lblQuicksearch' | translate }}" [(ngModel)]="searchTerm" autocomplete="off"
                            (keyup.enter)="onQuickSerch()" />
                        <div class="input-group-append">
                            <button type="button" class="btn btn-primary" (click)="onQuickSerch()">
                                <i class="fa fa-search" aria-hidden="true"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xl-2 col-lg-2 col-md-4 relative mt-3 mt-lg-0 justify-content-md-end justify-content-lg-start">
            <a>
                <button class="ml-2 btn btn-primary btn-md" href="javascript:void(0);" aria-label="Center Align"
                (click)='clearFilter()' ngbTooltip="{{ 'lblClearFilters' | translate }}" placement="bottom">
                <em class="far fa-times-circle font16 align-top"></em>
                </button>
            </a>
        </div>
        <div class="pl-2  align-items-center flex-sm-row flex-column justify-content-end ml-auto" >
            <!-- Excel -->
            <button type="button" (click)="exportAsXLSX()" 
                ngbTooltip="{{'lblExportExcel' | translate}}" placement="bottom" aria-label="Center Align" style="margin-right: 10px;">
                <img src="./../../../assets/images/excel.png" height="32" width="32" alt="" />
            </button>
            <!-- PDF -->
            <button class="btn btn-link icon-pdf" type="button" (click)="exportAsPDF()" 
                ngbTooltip="{{'lblExportPDF' | translate}}" placement="bottom" aria-label="Center Align">
                <em class="far fa-file fa-2x"></em>
                <span class="bdg">PDF</span>
            </button>
        </div>
    </div>
</div>


<!-- Body -->
<div class="container prel">
    <div class="row">
        <div class="c12">
            <div class="card mb-3">
                <!-- Body Header -->
                <div class="card-header d-flex justify-content-between" translate>
                    lblDeletedPlanning
                    <div class="font16 fontbold">
                        <span class="font16 fontnormal" translate>lblTotal</span>:&nbsp;
                        {{ totalCount }}
                        &nbsp;<span class="font16 fontnormal" translate>lblResults</span>
                    </div>
                </div>

                <!-- Body Content -->
                <div class="table-responsive max-h254" infinite-scroll [infiniteScrollDistance]="scrollDistance"
                    [infiniteScrollThrottle]="throttle" [scrollWindow]="false" (scrolled)="onScrollDown()">
                    <table class="tablest1" id="dealerPdf">
                        <thead>
                            <tr>
                                <th style="width: 55px" scope="col">#</th>
                                <th style="width: 10%" scope="col" translate>lblWoNo</th>
                                <th style="width: 20%" scope="col" sortable="licensePlate" (sort)="onSort($event)"
                                    translate>
                                    lblRegNumber
                                </th>
                                <th scope="col" translate>
                                    lblWoStatus
                                </th>
                                <th scope="col" sortable="customerName" (sort)="onSort($event)" translate>
                                    lblCustomerName
                                </th>
                                <th scope="col" sortable="mechanicName" (sort)="onSort($event)" translate>lblMechanic
                                </th>
                                <th scope="col" sortable="deletedBy" (sort)="onSort($event)" translate>
                                    lblDeletedBy</th>
                                <th scope="col" sortable="deletedDate" (sort)="onSort($event)" translate>
                                    lblDeletedDate</th>
                                <th scope="col" sortable="reason" (sort)="onSort($event)" translate>
                                    lblReason</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngIf="deletedPlanningList?.length > 0; else load_else">
                                <tr class="click" *ngFor="let appointment of deletedPlanningList; let i = index">
                                    <td>{{ i+1 }}</td>
                                    <td>
                                        <ngb-highlight [result]="appointment.workorderNo">
                                        </ngb-highlight>
                                    </td>
                                    <td>
                                        <div class="flmid">
                                            <div class="licplate LPNo d-flex">
                                                <span class="icn-flag" [ngClass]="licensePlateClass"></span>
                                                {{ appointment.licensePlate }}
                                            </div>
                                            <div class="imgWid">
                                                <img af-brand-logo [data-code]="appointment.brand" data-type="BRAND"
                                                    class="{{ appointment.brand }}-icon brandicon"
                                                    alt="not found" />
                                            </div>
                                        </div>
                                        <div class="mt-1">
                                            <ngb-highlight [result]="appointment.model"
                                                class="flmid semibold fs-12px lh-16px">
                                            </ngb-highlight>
                                        </div>
                                    </td>
                                    <td class="position-relative">
                                        <div class="mx-auto text-center">
                                            <div class="color-box" [ngbTooltip]="appointment.workOrderStatus"
                                                tooltipClass="tooltip-inner-width"
                                                [style.background-color]="appointment.workOrderStatusColor">
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <ngb-highlight [result]="appointment.customerName">
                                        </ngb-highlight>
                                        <div class="d-flex align-items-center fs-12px mt-1 lh-16px">
                                            <em _ngcontent-xdg-c220=""
                                                class="fas fa-phone-flip fs-10px fa-lg mr-2 clr666"></em>
                                            <span class="fs-12px" *ngIf="appointment && appointment.mobileCode">+{{
                                                appointment.mobileCode }}-</span>
                                            <ngb-highlight class="fs-12px" [result]="appointment.mobileNo">
                                            </ngb-highlight>
                                        </div>
                                    </td>
                                    <td>
                                        <ngb-highlight [result]="appointment.mechanicName">
                                        </ngb-highlight>
                                    </td>

                                    <td>
                                        <ngb-highlight [result]="appointment.deletedBy">
                                        </ngb-highlight>
                                    </td>
                                    <td>
                                        <ngb-highlight [result]="appointment.deletedDate  | date:'short'">
                                        </ngb-highlight>
                                    </td>
                                    <td>
                                        <ngb-highlight [result]="appointment.reason">
                                        </ngb-highlight>
                                    </td>
                                </tr>
                            </ng-container>
                            <ng-template #load_else>
                                <tr>
                                    <td colspan="8" class="no-record" translate>
                                        lblNoRecordsFound
                                    </td>
                                </tr>
                            </ng-template>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>